import { WSProvider } from '../../providers/WebSocketProvider';
import Chat from '../../components/ChatCmp';
import MSRooms from './MSRooms';
import MSMenu from './MSMenu';
import GACmp from "../../components/GACmp";

const TRACKING_ID = process.env.REACT_APP_GA4_TRACKING_ID;

const MSRouter = () => {
  return (
    <>
      <GACmp trackingIds={[TRACKING_ID]} />
      <MSRooms />
      <MSMenu />
      <WSProvider eventId='ms-room'>
        <Chat />
      </WSProvider>
    </>
  );
};

export default MSRouter;
